import moment from 'moment-timezone';
import { findTipospublicacao } from '@/services/tipospublicacao';
import { findAccounts } from '@/services/account';
import { productivity } from '@/services/relatorio';
import notifyError from '@/lib/notify-error';

moment.tz.setDefault('America/Sao_Paulo');

moment.locale('pt-br');

const Getters = {
  isAdmin(st, gt, rSt) {
    if (rSt.auth.account && rSt.auth.account.role[0].name === 'admin') {
      return true;
    }
    return false;
  },
  query(st, gt, rSt) {
    const query = [];
    if (rSt.route.query) {
      if (rSt.route.query.operationType) {
        const data = rSt.route.query.operationType;
        if (data) {
          query.push({
            title: 'Tipo de operação',
            data,
          });
        }
      } else {
        query.push({
          title: 'Tipo de operação',
          data: 'Todas',
        });
      }
      if (rSt.route.query.accountId) {
        const data = st.accounts.find(ac => Number(ac.id) === Number(rSt.route.query.accountId));
        if (data) {
          query.push({
            title: 'Colaborador',
            data: data.name,
          });
        }
      } else {
        query.push({
          title: 'Colaborador',
          data: 'Todos',
        });
      }
      if (rSt.route.query.idTipopublicacao) {
        const data = st.tipoPublicacoes.find(seg => Number(seg.idTipopublicacao)
            === Number(rSt.route.query.idTipopublicacao));
        if (data) {
          query.push({
            title: 'Tipo de acervo',
            data: data.tipoPublicacao,
          });
        }
      } else {
        query.push({
          title: 'Tipo de acervo',
          data: 'Todos',
        });
      }
      if (rSt.route.query.idSegmento) {
        const data = st.segmentos.find(seg => Number(seg.id)
        === Number(rSt.route.query.idSegmento));
        if (data) {
          query.push({
            title: 'Área',
            data: data.segmento,
          });
        }
      } else {
        query.push({
          title: 'Área',
          data: 'Todas',
        });
      }
      if (rSt.route.query.initialDate) {
        query.push({
          title: 'Data do documento inicial',
          data: rSt.route.query.initialDate,
        });
      }
      if (rSt.route.query.endDate) {
        query.push({
          title: 'Data do documento final',
          data: rSt.route.query.endDate,
        });
      }
      return query;
    }
    return [];
  },
  result(st) {
    return st.result;
  },
  csvData(st) {
    if (st.result.publicacoes) {
      return st.result.publicacoes.map(res => ({
        horario: moment(res.horario).tz('America/Sao_Paulo').format('DD/MM/YYYY HH:mm'),
        registro: res.registro.trim(),
        titulo: res.titulo,
        localizacao: res.localizacao,
        operacao: res.operacao,
        colaborador: res.colaborador,
        tipo: res.fisicoDigital,
      })).filter(pub => pub.operacao !== 'Exclusão de documento'
      && pub.operacao !== 'Inclusão de documento');
    }
    return [];
  },
  loading(st) {
    return st.loading;
  },
};
const mutations = {
  setTipoPublicacoes(state, tipoPublicacoes) {
    state.tipoPublicacoes = tipoPublicacoes;
  },
  setResult(state, result) {
    state.result = result;
  },
  setAccounts(state, accounts) {
    state.accounts = accounts;
  },
  setLoading(state, loading) {
    state.loading = loading;
  },
};
const actions = {
  afterRouteUpdate({ dispatch }) {
    dispatch('findTipospublicacao');
    dispatch('getResult');
    dispatch('loadAccounts');
  },
  findTipospublicacao({ commit }) {
    findTipospublicacao({ where: { base: 'S' } })
      .then(items => commit('setTipoPublicacoes', items));
  },
  getResult({ rootState, commit }) {
    commit('setLoading', true);
    const filter = Object.assign({}, rootState.route.query);
    productivity(filter)
      .then(result => commit('setResult', result))
      .catch(err => notifyError(err))
      .finally(() => {
        commit('setLoading', false);
      });
  },
  loadAccounts({ commit }) {
    const settings = {
      include: 'role',
    };
    return findAccounts(settings)
      .then((accounts) => {
        commit('setAccounts', accounts.items);
      });
  },
};

export default {
  namespaced: true,
  state: {
    segmentos: [],
    tipoPublicacoes: [],
    result: [],
    accounts: [],
    loading: false,
  },
  mutations,
  getters: Getters,
  actions,
};
